module.exports = __webpack_public_path__ + "img/icon-rechnung.7a0ee474.svg";